import { fetchWrapper } from "./fetchWrapper";
import { GingerMediaBaseUrl } from "./baseUrls";

export async function getUploadedImages() {
    return fetchWrapper(`${GingerMediaBaseUrl}/getUploadedImages`,
        {
            method: 'GET',
        }
    );
}